import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress, Grid, useTheme } from '@material-ui/core';
import { localize } from 'commons/LocalizedText/LocalizedText';
import { faFile, faPlus, faUpload } from '@fortawesome/pro-light-svg-icons';
import Dropzone from 'react-dropzone';

const useStyles = makeStyles((theme) => ({
  fileContainer: {
    borderRadius: '8px',
    border: `1px dashed gray`,
    padding: '20px 40px',
    marginBottom: '10px',
    width: '600px',
    cursor: 'pointer',
    height: '215px',
    textAlign: 'center'
  },
  instructions: {
    color: 'grey'
  },
  replaceWarning: {
    color: 'red'
  }
}));

export const FileDropZone = ({
  onFileDrop, 
  acceptedFormats
}) => {
  const classes = useStyles();
  const theme = useTheme();

  const [file, setFile] = useState(null);
  const [isLoadingFile, setIsLoadingFile] = useState(false);
  const [isDragActive, setIsDragActive] = useState(false);

  const loadFile = (files) => {
    if (!files) return
    const file = files[0];
    setIsLoadingFile(true);
    setFile(file);
    onFileDrop(file);
  }

  const clearFile = () => {
    setFile(null);
    onFileDrop(null);
  }

  useEffect(() => setIsLoadingFile(false), [file]);

  return (
    <Dropzone
      accept={acceptedFormats}
      multiple={false}
      onDragEnter={() => setIsDragActive(true)}
      onDragLeave={() => setIsDragActive(false)}
      onDrop={acceptedFiles => loadFile(acceptedFiles)}
      onFileDialogCancel={clearFile}
    >
      {({getRootProps, getInputProps}) => (
        <section>
          <div {...getRootProps()}>
            <input {...getInputProps()} />
            {isLoadingFile ?
              <div className={classes.fileContainer}>
                <CircularProgress size={100}/>
              </div>
              :
              <Grid
                alignItems='center'
                className={classes.fileContainer}
                container
                direction='column'
                justifyContent='center'
                spacing={1}
                wrap="nowrap"
              >
                { isDragActive ? (
                  <Grid item>
                    <FontAwesomeIcon color={theme.palette.primary.main} icon={faPlus} size="5x"/>
                  </Grid>
                ):(
                  <>
                    <Grid item>
                      { file ?
                        <Grid alignItems="center" container direction="column" justifyContent="center">
                          <Grid item>
                            <FontAwesomeIcon color={theme.palette.primary.main} icon={faFile} size="5x"/>
                          </Grid>
                          <Grid item>
                            {file.name}
                          </Grid>
                        </Grid>
                        :
                        <FontAwesomeIcon color={theme.palette.primary.main} icon={faUpload} size="5x"/>
                      }
                    </Grid>
                    <Grid className={classes.instructions} item>
                      {localize('dropzone.dragNDrop')}
                    </Grid>
                    <Grid className={classes.replaceWarning} item>
                      {localize('dropzone.fileWillBeReplaced')}
                    </Grid>
                  </>
                )}
              </Grid>
            }
          </div>
        </section>
      )}
    </Dropzone>


  );
};

FileDropZone.propTypes = {
  acceptedFormats: PropTypes.string,
  onFileDrop: PropTypes.func.isRequired
};

FileDropZone.defaultProps = {
  acceptedFormats: '*'
};